import { makeStyles } from '@material-ui/core';
import Tippy from '@tippyjs/react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    '&.tippy-box': {
      backgroundColor: 'unset',

      '&& > .tippy-arrow': {
        color: theme.colors.white,
      },

      '& > .tippy-content': {
        padding: 0,
      },
    },
  },
}));

const TippyBase = React.forwardRef((props, ref) => {
  const { className, ...otherProps } = props;
  const classes = useStyles();

  return (
    <Tippy
      offset={[0, 4]}
      arrow={false}
      {...otherProps}
      ref={ref}
      className={classNames(classes.root, className)}
    />
  );
});

TippyBase.propTypes = {
  className: PropTypes.string,
};
TippyBase.defaultProps = {
  className: undefined,
};

export default TippyBase;
